<template>
  <div
    class="bigdata_container"
    id="bigdata"
    v-loading="isLoading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div
      id="container"
      class="mymap"
      style="width: 100%; heigh: clac(100vh-70px)"
    ></div>
    <div class="customerTop">
      <img
          src="../assets/img/top.png"
          alt=""
          srcset=""
      />
      <div class="titleFirst"></div>
      <div class="titleSecond"></div>
      <h1>{{this.title.mechanismName}}民政监管可视化</h1>
    </div>
    <div class="quanp">
      <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
        onFullScreen ? "退出全屏" : "进入全屏"
      }}</el-button>
    </div>
    <transition name="nameoftransition">
      <div class="info_tisp" v-show="infoTisp">
        <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
      </div>
    </transition>
    <div id="map-container"></div>
    <div class="main_left">
      <!-- 养老概况 -->
      <div class="left_top left">
        <div class="headerBox">养老概况</div>
        <div class="iconBox">
          <div class="box" @click="initMarkers(1)">
            <div class="img">
              <img src="../assets/img/dangyuan_icon.png" alt="" />
            </div>
            <div class="txt">
              <i>智慧养老院</i><br />
              <span style="color: #ce040e">{{
                leftList.intelligenceHome
              }}</span>
            </div>
          </div>
          <div class="box" @click="initMarkers(2)">
            <div class="img">
              <img src="../assets/img/dangyuan_icon.png" alt="" />
            </div>
            <div class="txt">
              <i>入院</i><br />
              <span style="color: #d06209">{{ leftList.inhospitalOld }}</span>
            </div>
          </div>
        </div>
        <div class="headerBox">今日智能监控</div>
        <div class="iconBox" style="margin-top: 1vh">
          <div class="box">
            <div class="img">
              <img src="../assets/img/anquangan_icon.png" alt="" />
            </div>
            <div class="txt">
              <i>出院的老人&nbsp;&nbsp;&nbsp;</i><br />
              <span style="color: #ce040e">{{ leftList.outhospitalOld }}</span>
            </div>
          </div>
          <div class="box">
            <div class="img">
              <img src="../assets/img/dangyuan_icon.png" alt="" />
            </div>
            <div class="txt">
              <i>超时未归</i><br />
              <span style="color: #d06209">{{ leftList.outTime }}</span>
            </div>
          </div>
          <!-- <div class="box">
                        <div class="img">
                            <img
                                src="../assets/img/gongpinggan_icon.png"
                                alt=""
                            />
                        </div>
                        <div class="txt">
                            <i>超出范围</i><br />
                            <span style="color: #d06209">0</span>
                        </div>
                    </div> -->
        </div>
      </div>
      <div class="left_center left">
        <div class="headerBox">老人分析</div>
        <div class="typeClick">
          <!-- <span
                        :class="{ active: clickIndex == 1 }"
                        @click="changeClick(1)"
                        >年龄段占比</span
                    > -->
          <!-- <span
                        :class="{ active: clickIndex == 2 }"
                        @click="changeClick(2)"
                        >经济情况占比</span
                    > -->
        </div>
        <div class="type">
          <div
            id="typeEcharts"
            ref="typeEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="left_bottom left">
        <div class="headerBox">入院老人</div>
        <div class="type">
          <div
            id="servicesEcharts"
            ref="servicesEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="left_lastbottom left">
        <div class="headerBox">基本情况</div>
        <div class="type">
          <ul>
            <li>
              <span>{{ leftList.oldHome }}</span
              ><br />
              养老院
            </li>
            <li>
              <span>{{ leftList.houses }}</span
              ><br />
              房屋
            </li>
            <li>
              <span>{{ leftList.builtArea }}</span
              ><br />
              建筑面积
            </li>
            <li>
              <span>{{ leftList.retireePerson }}</span
              ><br />
              养老人员
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main_right">
      <div class="right_bottom right">
        <div class="headerBox">整改记录</div>
        <div class="type flex1" style="overflowx: auto">
          <!-- <div class="li" v-for="(item, index) in fkwt" :key="index">
                        <div class="img">{{ index + 1 }}</div>
                        <div class="txt" style="width: 15%">
                            {{ item.name }}
                        </div>
                        <div class="txt">
                            {{
                                item.evaluateTypeId == 26
                                    ? "信息回访"
                                    : "走访探视"
                            }}
                        </div>
                        <div class="txt">{{ item.feedback }}}</div>
                        <div class="time">{{ item.visitTime }}</div>
                    </div> -->
          <ul class="lilist">
            <li>整改机构</li>
            <li>整改主题</li>
            <li>整改内容</li>
            <li>整改时间</li>
          </ul>
          <ul class="lilist highauto" v-for="(item, id) in bullData" :key="id">
            <li>
              {{ item.mechanismName }}
            </li>
            <li>
              {{ item.content }}
            </li>
            <li>
              {{ item.theme }}
            </li>
            <li>
              {{ item.createDate }}
            </li>
          </ul>
        </div>
      </div>
      <div class="right_top right">
        <div class="headerBox">补贴发放记录</div>
        <div class="type">
          <div
            id="olderEcharts"
            ref="olderEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="right_center right">
        <div class="headerBox">院内监督</div>
        <div class="type">
          <div
            id="addressEcharts"
            ref="addressEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="right_bottom right lastbottom">
        <div class="headerBox">消防安全</div>
        <div class="type flex1" style="overflowx: auto">
          <!-- <div class="li" v-for="(item, index) in fkwt" :key="index">
                        <div class="img">{{ index + 1 }}</div>
                        <div class="txt" style="width: 15%">
                            {{ item.name }}
                        </div>
                        <div class="txt">
                            {{
                                item.evaluateTypeId == 26
                                    ? "信息回访"
                                    : "走访探视"
                            }}
                        </div>
                        <div class="txt">{{ item.feedback }}}</div>
                        <div class="time">{{ item.visitTime }}</div>
                    </div> -->
          <!-- <div
                        id="safe"
                        class="mymap"
                        style="width: 100%; height: 100%"
                    ></div> -->
        </div>
      </div>
    </div>
    <div class="bo_bottom">
      <ul>
        <li :class="{ active: val == 0 }" @click="lastClick(0,5)">
          <div class="menu_img jg01 jg02"></div>
          <span class="selected">养老机构</span>
        </li>
        <li :class="{ active: val == 1 }" @click="lastClick(1,5)">
          <div class="menu_img sq01 sq02"></div>
          <span class="selected">幸福苑</span>
        </li>
        <li :class="{ active: val == 2 }" @click="lastClick(2,5)">
          <div class="menu_img jj01 jj02"></div>
          <span class="selected">照料中心</span>
        </li>
      </ul>
    </div>
    <div class="serach_wrapper">
      <!-- <el-input
                v-model="keyword"
                placeholder="请输入姓名"
                style="width: 120px; margin-right: 12px"
            ></el-input
            > -->
      <el-select v-model="id" placeholder="请选择" @change="handleId">
        <el-option
          v-for="(item, index) in selectList"
          :key="index"
          :label="item.mechanismName"
          :value="item.mechanismId"
        >
        </el-option>
      </el-select>
      <el-button
        :disabled="this.display"
        type="primary"
        @click="handleSearch"
        style="margin-left: 10px"
        >搜索</el-button
      >
    </div>
    <add-service
      v-if="serviceState"
      :openData="serviceInfo"
      @cancleService="cancleService"
    ></add-service>
    <add-services
      v-if="serviceStates"
      :openData="serviceInfo"
      @cancleService="cancleService"
    ></add-services>
  </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import request from "@/utils/request.js"
import addService from "./addService.vue"
import addServices from "./addServices.vue"
export default {
  name: "visualized",
  components: {
    addService,
    addServices,
  },
  data() {
    return {
      title:{},
      serviceState: false,
      serviceInfo: {},
      serviceStates: false,
      display: true,
      id: "",
      val: 0,
      fen: [],
      form: {},
      leftList: {
        age50: "",
        age60: "",
        age70: "",
        age80: "",
        age90: "",
        intelligenceHome: null,
        inhospitalOld: null,
        outhospitalOld: null,
        outTime: null,
        oldHome: "",
        houses: "",
        builtArea: "",
        retireePerson: "",
      },
      selectList: [],
      subsidy: {},
      isCurrentMainIndex: 0,
      clickIndex: 1,
      infoTisp: false,
      isLoading: false,
      keyword: "", //搜索
      onFullScreen: false, // 是否全屏
      state: {
        //项目状态
        distribute: "",
        assessApproval: "",
        constructionApproval: "",
        toBeEvaluate: "",
        finishEvaluate: "",
        completed: "",
      },
      markers: [],
      // 弹窗
      dialogVisible2: false,
      stepIndex: 1,
      returnLookForm: {
        // 回访信息查看
        questionName1: "",
        replySelection1: "",
        reason1: "",
        questionName2: "",
        replySelection2: "",
        reason2: "",
        other: "",
      },
      dialogTitle: "",
      dialogVisible: false,
      dialogVisible3: false,
      dialogVisible4: false,
      formData: {
        //基本信息
        name: "", //姓名
        sex: "", //性别
        phone: "", //联系方式
        idCode: "", //身份证号
        age: "", //年龄
        oldType: "", //老人类型
        shengId: "", //省
        shiId: "", //市
        quId: "", //区
        street: "", //街道
        community: "", //社区
        address: "", //居住地址
        photo: "", //图片
        nation: "", //民族
      },
      mechanismType: 0,
      currentRow: null,
      // 图片预览
      dialogImageUrl: "",
      // 上传图片地址
      actionUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      imageUrl: "",
      addForm: {
        health: "",
        serviceDemand: [],
        selfCare: [],
        hraring: "",
        case: [],
      },
      addForm1: {
        health: "0",
      },
      bullData: [],
      map: null,
      // 表单测试数据
      tableDate: [],
      nation: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      total1: 0,
      chartOne: null,
      chartTwo: null,
      chartThree: null,
      chartFour: null,
      chartFive: null,
      fkwt: [],
      value: "",
      agelist: [],
    }
  },
  filters: {
    //时间格式化
    formatDate(date) {
      let dt = new Date(date)
      let dty = dt.getFullYear()
      let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
      let dtd = dt.getDate().toString().padStart(2, "0")
      let dth = dt.getHours().toString().padStart(2, "0")
      let dtmi = dt.getMinutes().toString().padStart(2, "0")
      let dts = dt.getSeconds().toString().padStart(2, "0")
      return dty + "-" + dtm + "-" + dtd
    },
  },
  created() {
    this.dataTitle()
    // this.$nextTick(() => {
    //     // this.ageType();
    //     // this.servicesType();
    //     // this.orderType();
    //     // this.addressType();
    // })
  },
  methods: {
    // 获取标题
    dataTitle() {
        this.$http
            .request({
                url: "/jgyl/admin/institute/info/findInstituteByUser",
                method: "POST",
                data: {},
            })
            .then((res) => {
                if (res.code == 200) {
                    this.title = res.content
                }
            })
    },
    // 取消查看
    cancleService(state) {
      this.serviceState = false
      this.serviceStates = false
      this.mapState = false
    },
    //获取id
    handleId(id) {
      if (id !== null) {
        this.display = false
      }
      console.log(id);
    },
    handleSearch() {
      request({
        url: "jgyl/admin/operationSubsidy/info/getStatisticsQuarter",
        method: "POST",
        data: {
          mechanismId: this.id,
        },
      }).then((res) => {
        console.log(res);
        this.subsidy = res.content.list[0]
        this.orderType()
      })
      this.initMarker()
    },
    //获取机构名称id
    async getMechanism(mechanismType) {
      await request({
        url: "/jgyl/admin/operationSubsidy/info/findOperationStatisticByType",
        method: "POST",
        data: {
          pageNo: "1",
          pageSize: "10",
          mechanismType,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content) {
            res.content.list.forEach((item, index) => {
              this.selectList.push(item)
            })
          }
        }
      })
    },
    //整改记录
    async record() {
      await request({
        url: "/jgyl/admin/rectification/info/findListByType",
        method: "POST",
        data: {
          pageNo: "1",
          pageSize: "10",
          type: "1",
          mechanismType: "0",
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content) {
            this.bullData = res.content.list
          }
        }
      })
    },
    //左边老人数据
    async recordOldMan() {
      await request({
        url: "/jgyl/admin/supervisionVisualization/info/oldsurvey",
        method: "POST",
        data: {
          mechanismType: this.mechanismType,
        },
      }).then((res) => {
        this.leftList.age50 = res.content.age50
        this.leftList.age60 = res.content.age60
        this.leftList.age70 = res.content.age70
        this.leftList.age80 = res.content.age80
        this.leftList.age90 = res.content.age90
        this.leftList.intelligenceHome = res.content.intelligenceHome
        this.leftList.inhospitalOld = res.content.inhospitalOld
        this.leftList.outhospitalOld = res.content.outhospitalOld
        this.leftList.outTime = res.content.outTime
        this.leftList.oldHome = res.content.oldHome
        this.leftList.houses = res.content.houses
        this.leftList.builtArea = res.content.builtArea
        this.leftList.retireePerson = res.content.retireePerson
        this.ageType()
        this.servicesType()
      })
    },
    //底部切换数据
    lastClick(val,index) {
      // this.isCurrentMainIndex = val
      // this.getActivity(val)
      
      this.id = ""
      this.subsidy = {}
      this.orderType()
      this.selectList = []
      
      this.ageType()
      this.servicesType()
      this.val = val
      if(index == 5){
        this.map.remove(this.markers)
        this.markers = []
      }
      if (val == 0) {
        this.mechanismType = 0
        this.oldData()
        this.initMarker()
        this.getMechanism(this.mechanismType)
        this.recordOldMan()
      } else if (val == 1) {
        this.mechanismType = 1
        this.oldData()
        this.initMarker()
        this.getMechanism(this.mechanismType)
        this.recordOldMan()
      } else {
        this.mechanismType = 2
        this.oldData()
        this.initMarker()
        this.getMechanism(this.mechanismType)
        this.recordOldMan()
      }
      
    },
    //曝光台
    async lrfkwt() {
      await request({
        url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
        method: "POST",
        data: {
          feedback: "1",
          states: "1",
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            let lrfkwt = []
            return
          }
          this.fkwt = res.content
          if (this.fkwt.length > 4) {
            this.fkwt.length = 4
          }
          // let fuwu = [
          //     res.content.ones,
          //     res.content.twos,
          //     res.content.threes,
          //     res.content.fours,
          // ];
          // this.addressType(juzhu);
        }
      })
    },

    // 入院老人
    async fwlbtj() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findTypeByWeek",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null || res.content != "null") {
            this.servicesType(res.content)
            return
          }
        }
      })
    },

    //院内监督
    async lrzu() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findJuzhuCommunity",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            let juzhu = []
            return
          }
          let juzhu = [
            res.content.ones,
            res.content.twos,
            res.content.threes,
            res.content.fours,
          ]
          this.addressType(juzhu)
        }
      })
    },

    //补贴发放记录
    async lrfw() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findMinzhengIndex",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.leibie = []
            return
          }
          let leibie = [res.content.ones, res.content.twos, res.content.threes]
          this.orderType(leibie)
        }
      })
    },
    //入院老人
    fenltj() {
      request({
        url: "/jjyl/admin/zfCustomer/info/findOldbytype",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.fen = []
            return
          }
          let fen = [
            res.content.ones,
            res.content.twos,
            res.content.threes,
            res.content.fours,
            res.content.fives,
            res.content.sixs,
          ]
          this.ageType(fen)
          this.fen = fen
        }
      })
    },

    async project() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findCustomers",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.state = []
            return
          }
          this.state = res.content
        }
      })
    },

    // 点击步骤条跳转
    changeStep(val) {
      this.stepIndex = val
    },

    // 行点击选中
    openDetails(row, event, column, cell) {
      this.row = row
      this.column = column
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },

    handleSelectionChange(data) {
      this.selectedData = data
    },
    // 弹框关闭
    handleClose() {
      this.dialogVisible = false
    },

    // 图片上传 start
    handleAvatarSuccess(res) {
      this.imageUrl = res.content
      this.addForm.img = res.content
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
        return
      }
    },
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },
    // 图片上传 end

    // 控制全屏展示
    showFullScreen() {
      this.onFullScreen = !this.onFullScreen
      if (this.onFullScreen) {
        var docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm = document.body //overwrite the element (for IE)
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    FullCreeen(element) {
      let el = document.getElementById("bigdata")
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell")
        if (wscript != null) {
          wscript.SendKeys("{F11}")
        }
      }
    },

    // 年龄段占比
    ageType() {
      this.chartOne = this.$echarts.init(this.$refs.typeEcharts)
      // 编写echart参数
      let option = {
        color: [
          "#DF38C1",
          "#9279E2",
          "#1999F7",
          "#87BF62",
          "#D1364B",
          "#FFB652",
        ],
        tooltip: {
          trigger: "item",
          formatter: "{d}" + "%",
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "40%"],
            data: [
              { value: this.leftList.age50, name: "50%" },
              { value: this.leftList.age60, name: "60%" },
              { value: this.leftList.age70, name: "70%" },
              { value: this.leftList.age80, name: "80%" },
              { value: this.leftList.age90, name: "90%" },
            ],
          },
        ],
      }
      // 设置图表的参数
      this.chartOne.setOption(option)
    },

    // 入院老人
    servicesType() {
      this.chartThree = this.$echarts.init(this.$refs.servicesEcharts)
      let option = {
        color: ["#37F884"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#ffffff",
          },
          data: ["50", "60", "70", "80", "90"],
        },
        image: "",
        yAxis: {
          splitLine: {
            //网格线
            lineStyle: {
              type: "dotted", //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            color: "#fff",
          },
          name: "人数",
          nameTextStyle: {
            color: "#fff",
          },
          type: "value",
          data: [
            {
              textStyle: {
                color: "#fff",
              },
            },
          ],
        },
        series: {
          name: "",
          type: "bar",
          barWidth: "20%",
          data: [
            { value: this.leftList.age50, name: "50" },
            { value: this.leftList.age60, name: "60" },
            { value: this.leftList.age70, name: "70" },
            { value: this.leftList.age80, name: "80" },
            { value: this.leftList.age90, name: "90" },
          ],
        },
      }
      this.chartThree.setOption(option)
    },
    // 补贴发放记录
    orderType() {
      this.chartFour = this.$echarts.init(this.$refs.olderEcharts)
      // 编写echart参数
      let option = {
        color: ["#C129FF", "#41A6FD", "#50BBE1"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          x: "10%",
          y: "4%",
          bottom: "2%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
          data: ["第一季度", "第二季度", "第三季度", "第四季度"],
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            data: [
              { value: this.subsidy.quarter1 },
              { value: this.subsidy.quarter2 },
              { value: this.subsidy.quarter3 },
              { value: this.subsidy.quarter4 },
            ],
            type: "line",
          },
        ],
      }
      // 设置图表的参数
      this.chartFour.setOption(option)
    },
    // 院内监督
    addressType(juzhu) {
      this.chartFive = this.$echarts.init(this.$refs.addressEcharts)
      let option = {
        color: ["#32A5A1"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          x: "10%",
          y: "4%",
          bottom: "2%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#fff",
              interval: 0, //强制显示
            },
            axisLine: {
              lineStyle: {
                color: "#FFF",
                width: 1, //这里是为了突出显示加上的
              },
            },
            data: ["5月", "9月", "10月", "11月"],
          },
        ],
        yAxis: {
          splitLine: {
            //网格线
            lineStyle: {
              type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            color: "#fff",
          },
          nameTextStyle: {
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              color: "#FFF",
              width: 1, //这里是为了突出显示加上的
            },
          },
          type: "value",
        },
        series: {
          name: "",
          type: "bar",
          barWidth: "20%",
          data: [juzhu[0], juzhu[1], juzhu[2], juzhu[3]],
        },
      }
      // 设置图表的参数
      this.chartFive.setOption(option)
    },

    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.formData.shiId = ""
      this.formData.quId = ""
      // let city = await this.getDistrict(val);
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.formData.quId = ""
      this.areaList = []
      this.streetList = []
      // let area = await this.getDistrict(val);
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
    },
    // 地址 end
    // safeMap() {
    //     //地图加载
    //     return new Promise((resolve, reject) => {
    //         this.map = new AMap.Map("safe", {
    //             resizeEnable: true,
    //             mapStyle: "amap://styles/darkblue",
    //             zoom: 9,
    //         })
    //         resolve()
    //     })
    // },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("container", {
          resizeEnable: true,
          mapStyle: "amap://styles/darkblue",
          zoom: 9,
        })
        if(this.$store.state.orgAreaLevel==1||this.$store.state.orgAreaLevel==2||this.$store.state.orgAreaLevel==3) {
            let cities=[this.$store.state.orgAreaName]
            for(let i=0;i<cities.length;i++) {
              this.areaBG(this.map, cities[i])
              this.map.setZoom(8)
            }
          } else if(this.$store.state.orgAreaLevel==4||this.$store.state.orgAreaLevel==5) {
            console.log("社区，街道", this.$store.state.orgId)

            if(this.$store.state.orgId!=0) {
              this.$http.request({
                url: '/rbac/admin/org/info/findOrgById',
                method: 'POST',
                data: {
                  id: this.$store.state.orgId
                },
              }).then((res) => {
                var polygonArr=[]
                res.content.pointPosition
                  .split(",")
                  .forEach((i) => {
                    console.log(i)
                    polygonArr.push(i.split(":"))
                  })
                this.polygon=new AMap.Polygon({
                  map: this.map,
                  strokeWeight: 1,
                  path: polygonArr,
                  fillOpacity: 0.3,
                  fillColor: "#2191E6",
                  strokeColor: "#007CDB",
                })
                this.map.setZoomAndCenter(14, [polygonArr[0].lng, polygonArr[0].lat])
                this.polygon.setMap(self.map)
              })
            }
          }
        resolve()
      })
    },
areaBG(map, cityName) {
        console.log(cityName, "cityName")
        AMap.service("AMap.DistrictSearch", function() {
          let opts={
            subdistrict: 0,
            extensions: "all",
            level: "district", // 查询行政级别为市
          }
          // 实例化DistrictSearch
          let district=new AMap.DistrictSearch(opts)
          district.setLevel("district")
          // 行政区查询
          district.search(`${cityName}`, function(status, result) {
            // 获取边界信息
            let bounds=result.districtList[0].boundaries
            let polygons=[]
            if(bounds) {
              for(let i=0, l=bounds.length;i<l;i++) {
                // 生成行政区划polygon
                let polygon=new AMap.Polygon({
                  map: map,
                  strokeWeight: 1,
                  path: bounds[i],
                 fillOpacity: 0.3,
                  fillColor: "#2191E6",
                  strokeColor: "#007CDB",
                })
                polygons.push(polygon)
                console.log(polygon)
              }
            }
          })
        })
      },
    // // 地图打点
    // renderMapMarker(addresses, name = "") {
    //     let self = this;
    //     let geocoder = new AMap.Geocoder({
    //         city: "", //城市设为北京，默认：“全国”
    //     });
    //     var endIcon = new AMap.Icon({
    //         size: new AMap.Size(49, 56),
    //         image: require("../assets/img/end_icon.png"),
    //         imageSize: new AMap.Size(38, 42),
    //     });
    //     geocoder.getLocation(addresses, function (status, result) {
    //         if (status === "complete" && result.geocodes.length) {
    //             for (let i = 0; i < result.geocodes.length; i += 1) {
    //                 let marker = new AMap.Marker({
    //                     position: result.geocodes[i].location,
    //                     icon: endIcon,
    //                 });
    //                 self.markers.push(marker);
    //                 marker.on("mouseover", (e) => {
    //                     marker.setTitle(name);
    //                 });
    //                 marker.on("click", (e) => {
    //                     self.dialogVisible = true;
    //                 });
    //             }
    //             self.map.add(self.markers);
    //             self.map.setFitView(self.markers);
    //         }
    //     });
    // },
    //获取地址
    getDistrict(name = "中国") {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 3, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0].districtList)
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    initMarkers(val) {
      this.map.remove(this.markers)
      this.markers = []
      if (val == 1) {
        this.initMarker()
      } else {
        this.oldData()
      }
    },
    oldData() {
      this.$http
        .request({
          url: "/jgyl/admin/supervisionVisualization/info/oldPersonLocation",
          method: "POST",
          data: {
            // pageSize: -1,
            // pageNo: 1,
            // intoState: 1,
            mechanismType: this.mechanismType,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              let data = res.content.filter(
                (item) => item.latitude && item.longitude
              )
              this.image = require("../assets/img/end_icon.png")
              this.renderMapMarker(data)
            }
          }
        })
    },

    initMarker() {
      this.$http
        .request({
          url: "/jgyl/admin/supervisionVisualization/info/houseLocation",
          method: "POST",
          data: {
            pageSize: 100,
            pageNo: 1,
            mechanismType: this.mechanismType,
            mechanismId: this.id,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              let data = res.content.filter(
                (item) => item.addressLat && item.addressLng
              )
              this.image = require("../assets/img/shj-icon.png")
              this.renderMapMarker(data, 1)
            }else {
              this.map.remove(this.markers)
              this.markers = []
            }
          }
        })
    },
    renderMapMarker(data, type) {
      let self = this
      if (data.length) {
        var endIcon = new AMap.Icon({
          size: new AMap.Size(49, 56),
          image: this.image,
          imageSize: new AMap.Size(38, 42),
        })
        data.forEach((item) => {
          let marker = new AMap.Marker({
            position: [
              item.longitude || item.addressLng,
              item.latitude || item.addressLat,
            ],
            icon: endIcon,
          })
          self.markers.push(marker)
          marker.on("mouseover", (e) => {
            if (type == 1) {
              marker.setTitle(item.mechanismName)
            } else {
              marker.setTitle(item.name)
            }
          })
          marker.on("click", (e) => {
            if (type == 1) {
              this.serviceStates = true
              this.serviceInfo = {}
              this.serviceInfo = {
                id: item.id,
                state: true,
                title: "查看",
              }
            } else {
              this.serviceState = true
              this.serviceInfo = {}
              this.serviceInfo = {
                id: item.id,
                state: true,
              }
            }
            // self.dialogVisible = true
            // self.getElderlyInformation(item.id)
            // self.getById(item.id)
          })
        })
      }
      self.map.add(self.markers)
      self.map.add(self.polygon)
      self.map.setFitView(self.polygon) //视口自适应
      // self.map.setFitView(self.markers)
    },
    getById(id) {
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/getById",
          method: "POST",
          data: {
            id,
          },
        })
        .then((res) => {
          let data = res.content
          //基本信息
          this.formData.name = data.name //姓名
          this.formData.sex = data.sex //性别
          this.formData.phone = data.phone //联系方式
          this.formData.idCode = data.idNumber //身份证号
          this.formData.age = data.age //年龄
          this.formData.oldType = data.minzhengIndex //老人类型
          this.formData.shengId = data.shengId //省
          this.formData.shiId = data.shiId //市
          this.formData.quId = data.quId //区
          this.formData.street = data.street //街道
          this.formData.community = data.community //社区
          this.formData.address = data.address //居住地址
          this.formData.photo = data.photo //图片
          this.formData.nation = data.nation //民族
          this.formData.userType = String(data.type) //
        })
    },
  },
  async mounted() {
    //  this.lrfkwt();
    this.recordOldMan()
    // this.ageType()
    // this.servicesType()
    this.record()
    // this.changeClick()
    this.lastClick("0")
    // this.getMechanism()
    // this.servicesType()
    this.lrzu()
    this.lrfw()
    //this.ageType()
    this.fenltj()
    // this.project();

    this.initMarker()
    this.oldData()
    this.fwlbtj()
    // this.getActivity(0)
    let self = this
    await self.loadMap()
    // await self.safeMap()
    // let address = ["庐阳区", "包河区", "长丰县", "肥东县"];
    // address.forEach((item) => {
    //     this.renderMapMarker(item, item);
    // });
    window.addEventListener("resize", () => {
      // 自适应所有echarts
      this.chartOne && this.chartOne.resize()
      this.chartTwo && this.chartTwo.resize()
      this.chartThree && this.chartThree.resize()
      this.chartFour && this.chartFour.resize()
      this.chartFive && this.chartFive.resize()
      const handleResize = () => {
        if (!checkFull()) {
          self.onFullScreen = false
        }
      }
      window.onresize = handleResize
      function checkFull() {
        let isFull =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement
        if (isFull === undefined) isFull = false
        return isFull
      }
    })
    let arr = [[{ week: 1 }], [{ week: 2 }, { week: 3 }], []]

    // const self = this
    document.addEventListener(
      "fullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "msfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "mozfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "webkitfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )
  },
  beforeDestory() {
    window.removeEventListener("resize")
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  border-bottom: 1px solid #ccc;
}
/deep/#typeEcharts canvas {
  top: 8px !important;
}
/deep/#addressEcharts canvas {
  top: -12px !important;
  // height:180px !important;
  // width:380px !important;
}
.customerTop {
        img {
            width: 100%;
            height: 88px;
        }
        h1 {
            color: #6ebcff;
            position: absolute;
            text-align: center;
            font-weight: bolder;
            font-size: 35px;
            left: 0;
            top: 0;
            width: 100%;
            height: 78px;
            line-height: 78px;
            z-index: 3;
        }
        .titleFirst {
            min-width: 560px;
            position: absolute;
            width: 560px;
            // border-top: 78px solid #1e69b6;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -310px;
            z-index: 2;
        }
        .titleSecond {
            min-width: 620px;
            width: 620px;
            position: absolute;
            // border-top: 78px solid #103b71;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -340px;
        }
    }
#olderEcharts canvas {
  width: 283px;
  height: 334px;
  top: 23px;
}
#container {
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  bottom: 0;
  z-index: 1;
}
.nameoftransition-enter-active,
.nameoftransition-leave-active {
  transition: opacity 0.5s;
}
.nameoftransition-enter, .nameoftransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.box {
  div:hover {
    cursor: pointer;
  }
}
//引入的字体样式
@font-face {
  font-family: "Unidtrsmled";
  src: url(../assets/font/UnidreamLED.ttf);
}
.bo_bottom {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 432px;
  height: 44px;
  background: url("../assets/img/toggle.png") no-repeat center;
  background-size: 100% 100%;
  z-index: 99999;
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    li {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28%;
      cursor: pointer;
      span {
        font-size: 12px;
        margin-left: 2px;
        color: rgba(255, 255, 255, 0.4);
      }
      .menu_img {
        height: 36px;
        width: 36px;
      }
      .jg01 {
        background: url(../assets/img/jigou_icon.png) no-repeat;
        background-size: 100%;
      }
      .active .jg02 {
        background: url(../assets/img/jigou2_icon.png) no-repeat;
        background-size: 100%;
      }
      .sq01 {
        background: url(../assets/img/shequ_icon.png) no-repeat;
        background-size: 100%;
      }
      .active .sq02 {
        background: url(../assets/img/shequ2_icon.png) no-repeat;
        background-size: 100%;
      }
      .jj01 {
        width: 30px;
        height: 30px;
        background: url(../assets/img/jujia_icon.png) no-repeat;
        background-size: 100%;
      }
      .active .jj02 {
        width: 30px;
        height: 30px;
        background: url(../assets/img/jujia2_icon.png) no-repeat;
        background-size: 100%;
      }
    }
    .active {
      span {
        color: #fff;
      }
    }
  }
}
.quanp {
  width: 200px;
  height: 100px;
  float: right;
  position: absolute;
  top: 20px;
  right: -110px;
  z-index: 100;
  button {
    padding: 10px;
  }
}
.bigdata_container {
  * {
    box-sizing: content-box;
  }
}
/deep/ .el-carousel__container {
  height: 100% !important;
  .el-icon-arrow-left:before,
  .el-icon-arrow-right:before {
    color: #489aff;
    font-weight: bold;
    font-size: 22px;
  }
}
.bigdata_container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url("../assets/img/bg.png") no-repeat center center;
  background-size: 100% 100%;
  .header {
    margin: auto;
    width: 90%;
    height: 100px;
    background: url("../assets/img/top.png") no-repeat center center;
    background-size: 100%;
  }
  .main_left {
    margin-top: 0%;
    position: absolute;
    width: 23%;
    height: calc(100vh - 100px);
    margin-left: 1%;
    z-index: 2;
    .left {
      margin-top: 2%;
      width: 100%;
      padding-left: 1%;
      .headerBox {
        margin-left: 10px;
        line-height: 4vh;
        height: 4vh;
        color: #01c5e2;
      }
      .iconBox {
        height: 6vh; //calc(100% - 127px)
        display: flex;
        .box {
          color: #fff;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          display: flex;
          height: 100%;
          margin-top: 0.5vh;
          .img {
            img {
              margin: 0 10%;
              width: 68%;
              margin-right: 1%;
            }
          }
          .txt {
            font-size: 13px;
            i {
              margin-left: -12px;
              display: inline-block;
              font-style: normal;
              margin-bottom: 3px;
            }
            span {
              font-size: 22px;
              font-family: Unidtrsmled;
              margin-left: -6px;
            }
          }
        }
      }
    }
    .left_top {
      background: url(../assets/img/a3.png);
      background-size: 100% 100%;
      height: 24vh;
    }
    .left_center {
      margin-top: 10px;
      background: url(../assets/img/left.png);
      background-size: 100% 100%;
      height: 21vh;
      .typeClick {
        margin-right: 10px;
        margin-top: -12px;
        float: right;
        color: #fff;
        position: relative;
        z-index: 1000;
        font-size: 12px;
        .active {
          padding-bottom: 2px;
          border-bottom: 1px solid #038bff;
        }
        span {
          margin: 0 10px;
        }
      }
      .type {
        height: 15vh;
        width: 100%;
      }
    }

    .left_bottom {
      margin-top: 10px;
      background: url(../assets/img/left.png);
      background-size: 100% 100%;
      height: 26vh;
      overflow-y: auot;
      .type {
        height: 20vh;
        width: 100%;
      }
    }
    .left_lastbottom {
      margin-top: 10px;
      background: url(../assets/img/left.png);
      background-size: 100% 100%;
      height: 14vh;
      overflow-y: auto;
      ul {
        overflow: hidden;
        li:nth-child(2n + 1) {
          margin-left: 1%;
        }
        li {
          float: left;
          width: 47%;
          margin-right: 2%;
          font-size: 14px;
          color: #fff;
          text-align: center;
          background: url(../assets/img/dizhi1_icon.png) no-repeat center;
          height: 58px;
          background-size: 100% 100%;
          margin-bottom: 10px;
          span {
            color: #2ad4f3;
            margin-bottom: 2px;
            margin-top: 10px;
            display: inline-block;
          }
        }
      }
    }
  }

  .main_right {
    margin-top: 0%;
    position: absolute;
    right: 0;
    width: 22.5%;
    margin-right: 1%;
    height: calc(100vh - 100px);
    z-index: 2;
    overflow-y: auto;
    .right {
      margin-top: 2%;
      width: 100%;
      padding-left: 1%;
      .headerBox {
        margin-left: 10px;
        line-height: 36px;
        height: 36px;
        color: #01c5e2;
      }
      .iconBox {
        height: calc(100% - 50px);
        display: flex;
        .box {
          color: #fff;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          display: flex;
          .img {
            img {
              margin: 0 10%;
              width: 68%;
            }
          }
          .txt {
            font-size: 13px;
            span {
              font-size: 22px;
              font-family: Unidtrsmled;
            }
          }
        }
      }
    }
    .right_top {
      background: url(../assets/img/right.png);
      background-size: 100% 100%;
      height: 26vh;
      .type {
        height: 20vh;
        width: 100%;
      }
    }

    .right_center {
      background: url(../assets/img/right.png);
      background-size: 100% 100%;
      .type {
        height: 23vh;
        width: 100%;
      }
    }

    .lastbottom {
      overflow: auto;
    }
    .lastbottom .type {
      height: 100px;
    }
    .right_bottom {
      background: url(../assets/img/right.png);
      background-size: 100% 100%;
      height: 18vh;
      overflow: hidden;
      .type {
        height: 14vh;
        width: 100%;
        overflow-y: auto;
        .lilist {
          margin-left: 5%;
          li {
            color: #fff;
            font-size: 12px;
            height: 20px;
            line-height: 20px;
            float: left;
            width: 22%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .flex1 {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
// 搜索
/deep/ .serach_wrapper {
  z-index: 2;
  position: absolute;
  left: 50%;
  top: 15vh;
  transform: translateX(-50%);
  .el-button {
    color: #0291c2;
    background: #041d4d;
    border: none;
  }
  .el-input__inner {
    color: #0291c2;
    background: #102132;
    border-color: #233b87;
  }
}
// 弹框步骤条样式
/deep/ .el-step__icon.is-text {
  border-radius: 5px;
}
/deep/ .is-finish .el-step__icon {
  background: #409eff;
}
/deep/ .el-step__icon {
  width: auto;
  padding: 15px 20px;
  color: #ffffff;
  cursor: pointer;
  border: none;
  background: #c0c4cc;
}
/deep/ .el-step {
  height: 40px;
  margin-bottom: 24px;
}
/deep/ .el-step.is-horizontal .el-step__line {
  top: 16px;
}

// 上传图片
/deep/ .upImg {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
// 回访内容
.return_visit_form {
  .formheader {
    display: flex;
    justify-content: space-between;
    padding: 24px 0 36px;
  }
}
</style>
